module.exports = __webpack_public_path__ + "static/karalis-bdb4096e82e07dd538e55e77a61c6658.png";